var HomeWidgets = window.HomeWidgets = (function () {
	var selectors = {
		homeWidget: '[js-node="home-widget"]',
		header: '[js-node="home-widget-header"]'
	}

	var init = function () {
		bindUI();
	}

	var dispose = function () {
		unblindUI();
	}

	var bindUI = function () {
		$(document).on('click.homeWidgetHeader', selectors.header, function () {
			$(this).closest(selectors.homeWidget).toggleClass('m-collapsed');
		});
	}

	var unbindUI = function () {
		$(document).off('click.homeWidgetHeader');
	}

	return {
		init: init,
		dispose: dispose,
		bindUI: bindUI,
		unbindUI: unbindUI
	}
}());

$(function () {
	HomeWidgets.init();
});